(() => {
  'use strict';
  if (customElements.get('bavi-shipping-countdown')) return;
  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  const parts = ms => Object.fromEntries(formatter.formatToParts(new Date(ms)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
  function nextBoundary(now) {
    const p = parts(now);
    const target = Date.UTC(p.year, p.month - 1, p.day, (Math.floor(p.hour / 6) + 1) * 6);
    let guess = target;
    for (let i = 0; i < 3; i++) {
      const q = parts(guess);
      const offset = Date.UTC(q.year, q.month - 1, q.day, q.hour, q.minute, q.second) - guess;
      guess = target - offset;
    }
    return guess;
  }
  const active = new Set();
  let deadline = 0;
  function update() {
    const now = Date.now();
    if (!deadline || now >= deadline || deadline - now > 7 * 3600000) deadline = nextBoundary(now);
    const seconds = Math.max(0, Math.ceil((deadline - now) / 1000));
    const pad = n => String(n).padStart(2, '0');
    const value = pad(Math.floor(seconds / 3600)) + 'h' + pad(Math.floor(seconds / 60) % 60) + 'min' + pad(seconds % 60) + 's';
    active.forEach(el => {
      const clock = el.querySelector('[data-shipping-clock]');
      const prefix = el.querySelector('[data-shipping-prefix]');
      const suffix = el.querySelector('[data-shipping-suffix]');
      if (!clock || !prefix || !suffix) return;
      if (clock.textContent !== value) clock.textContent = value;
      clock.hidden = false;
      prefix.hidden = false;
      suffix.textContent = ' pour une expédition demain';
    });
  }
  customElements.define('bavi-shipping-countdown', class extends HTMLElement {
    connectedCallback() { active.add(this); update(); }
    disconnectedCallback() { active.delete(this); }
  });
  setInterval(() => { if (!document.hidden && active.size) update(); }, 1000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
})();
